import "./three-mobile-images.scss";

var wrapper = document.getElementById("js-three-mobile-images-wrapper");
var width = window.innerWidth;
var indicatorDots = document.getElementsByClassName("js-indicator");
var images = document.getElementsByClassName("js-image");
var totalImages = 3;
var activeIndicator = document.getElementsByClassName("active-indicator");

//Function for Indicator Dots
function changeIndicator(currentActive, newActive) {
  currentActive.classList.remove("active-indicator");
  indicatorDots[newActive].classList.add("active-indicator");
}

function removeImageClass() {
  for (var i = 0; i < images.length; i++) {
    images[i].classList.remove("active-image");
  }
}

// Mobile Functionality
if (wrapper && width < 768) {
  //Fires everytime the case studies block is scrolled
  wrapper.addEventListener("scroll", function () {
    var imagesWidth = images[0].offsetWidth;
    var maxPossibleWidth = imagesWidth * totalImages;
    var wrapperScrollPos = wrapper.scrollLeft + imagesWidth;
    var currentlyActive = activeIndicator[0];

    removeImageClass();
    if (wrapperScrollPos == imagesWidth) {
      images[0].classList.add("active-image");
      changeIndicator(currentlyActive, 0);
    }

    if (wrapperScrollPos > imagesWidth * 2.5) {
      images[2].classList.add("active-image");
      changeIndicator(currentlyActive, indicatorDots.length - 1);
      return;
    } else if (wrapperScrollPos >= imagesWidth * 1.8) {
      images[1].classList.add("active-image");
      changeIndicator(currentlyActive, 1);
    }
  });
}
